module.exports = __webpack_public_path__ + "static/media/cq_messaggio_letto.d996d4b5.svg";